module.exports = __webpack_public_path__ + "img/house-header.a64846e7.jpg";